<template>
    <section class="search-hero">
        <div class="search-hero__top">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="page-control">
                            <a class="btn-link btn-link--3" href="#" target="_self" title="Terug">
                                <svgComponent
                                    :width="24"
                                    :height="24"
                                    class-name="icon-arrow"
                                    icon-name="arrow-left"></svgComponent>
                                <span>Terug</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="search-hero__form">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <SearchForm></SearchForm>
                    </div>
                </div>
            </div>
        </section>

        <section class="search-hero__controls">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <FilterTrigger></FilterTrigger>
                    </div>
                </div>
            </div>
        </section>
    </section>

    <section class="ridingschool__body">
        <div class="container">
            <div class="row">
                <div class="col-lg-2 offset-lg-1 d-none d-lg-block">
                    <FilterList v-if="isDesktop"></FilterList>
                </div>
                <div class="col-lg-9" v-if="ridingschoolStore.results.length > 0">
                    <ResultCard
                        v-for="item in ridingschoolStore.results"
                        :key="`ridingschool-${item.umbracoId}`"
                        :id="item.umbracoId"
                        :image="item.image"
                        :title="item.title"
                        :street="item.street"
                        :house-number="item.houseNumber"
                        :postal-code="item.postalCode"
                        :city="item.city"
                        :url="item.url"
                        :courses="item.courses"></ResultCard>
                </div>
                <div class="col-lg-9" v-else>
                    <p>
                        Helaas hebben wij voor jouw zoekopdracht geen resultaten gevonden. Vergroot
                        de zoekafstand in de filters of voer een nieuwe zoekopdracht in.
                    </p>
                </div>
            </div>

            <div class="row" v-if="ridingschoolStore.results.length < ridingschoolStore.totalItems">
                <div class="col-lg-9 offset-lg-3">
                    <div class="load-more">
                        <button
                            v-if="isDesktop"
                            @click="loadMore"
                            type="button"
                            class="btn-default btn-default--1">
                            Laad meer
                        </button>
                        <button
                            v-else
                            @click="loadMore"
                            type="button"
                            class="btn-default btn-default--3">
                            Laad meer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
// Vue
import { ref, onBeforeMount, watch, computed } from 'vue';

// Components
import svgComponent from '../../components/svgComponent.vue';
import SearchForm from './components/search-form.component.vue';
import FilterTrigger from './components/filter-trigger.component.vue';
import FilterList from './components/filter-list.component.vue';
import ResultCard from './components/result-card.component.vue';

// Composables
import { useMediaQuery } from '../../composables/useMediaQuery';

// Store
import { useRidingschoolStore } from './store/ridingschool.store';

// Models
import { IFilterGroup } from './model/ridingschool.models';

const props = defineProps<{
    filterprops: IFilterGroup[];
}>();

const isDesktop = useMediaQuery('(min-width: 1024px)');
const ridingschoolStore = useRidingschoolStore();

const filterData = ref<IFilterGroup[]>(props.filterprops);
ridingschoolStore.setFilters(filterData.value);

function loadMore() {
    ridingschoolStore.incrementPage();

    if (ridingschoolStore.searchParams) {
        const newPage = ridingschoolStore.searchParams;
        newPage?.set('page', ridingschoolStore.page.toString());

        window.history.replaceState(
            {},
            '',
            `${location.pathname}?${decodeURIComponent(ridingschoolStore.searchParams.toString())}`
        );

        ridingschoolStore.loadMore(ridingschoolStore.searchParams.toString());
    }
}

function handleSearch(query: string) {
    ridingschoolStore.fetchSearchResults(query);
}

const cSearchParams = computed(() => {
    return ridingschoolStore.searchParams?.toString();
});

watch(cSearchParams, () => {
    const queryString = ridingschoolStore.searchParams?.toString()
        ? ridingschoolStore.searchParams?.toString()
        : '';
    window.history.replaceState({}, '', `${location.pathname}?${decodeURIComponent(queryString)}`);

    if (cSearchParams.value) {
        handleSearch(cSearchParams.value);
    } else {
        handleSearch('');
        ridingschoolStore.setPage(0);
    }
});

onBeforeMount(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const query = params.get('query');
    const page = params.get('page');

    ridingschoolStore.$patch({
        url: url,
        searchParams: params,
        query: query,
        page: page ? parseInt(page) : 0,
    });
});
</script>
